/**
 *		TOGGLE EVENT REGISTRATION
 *		- Register user for event if not already registered.
 */
function toggleEventRegistration(event) {

	if (dragging) return;

	var target = event.target.closest("[data-event]");
	
	if (target) {
		event.preventDefault();
		event.stopPropagation();

		if(window.loggedIn === false)
		{
			return window.location.replace("/account");
		}

		var eventId = target.dataset.event;
		var eventDateId = target.dataset.date;

		axios.get('/rd-api/events/' + eventId + '/dates/' + eventDateId)
		.then(function(response) {
			showUnsubscibeFromEventModal(eventId, eventDateId, target)
		}).catch(function(error) {
			showSubscibeToEventModal(eventId, eventDateId, target)
		})
	}
}

function toggleActiveEvents()
{
	axios.get('/rd-api/events'
	).then(function(response) {
		let events = response.data.events
		for(let i = 0; i < events.length; i++)
		{
			var eventDateId = events[i]['craft_date_id'];
			var elements = document.querySelectorAll('[data-date="'+eventDateId+'"]')
			console.log(elements)
			for(let f = 0; f < elements.length; f++)
			{
				// elements[f].classList.add('favorite');
				elements[f].textContent = "Unsubscribe Fom Reminders";
			}
		}
	}).catch(function(error) {
		console.log(error)
	})
}

function showSubscibeToEventModal(eventId, eventDateId, target) {
	Swal.fire({
		title: 'Subscribe to Reminders?',
		text: 'Would you like to receive event reminders leading up to the start of this event time?',
		icon: 'info',
		showCancelButton: true,
		confirmButtonText: 'Yes, Subscribe',
		confirmButtonColor: '#b73436',
		cancelButtonText: 'No Thanks',
		cancelButtonColor: '#bdbfc1'
	  }).then(function(result) {
		if(result.value) {
			sendEventRegistrationApiRequest(eventId, eventDateId);
			target.textContent = "Unsubscribe Fom Reminders";
		}
	})
}

function showUnsubscibeFromEventModal(eventId, eventDateId, target) {
	Swal.fire({
		title: 'Unsubscibe?',
		text: 'You are currently subscribed to receive reminders for this event time. Would you like to unsubscribe?',
		icon: 'info',
		showCancelButton: true,
		confirmButtonText: 'Unsubscribe',
		confirmButtonColor: '#b73436',
		cancelButtonText: 'Nevermind',
		cancelButtonColor: '#bdbfc1'
	  }).then(function(result) {
		if(result.value) {
			sendEventRegistrationApiRequest(eventId, eventDateId);
			target.textContent = "Subscribe To Reminders";
		}
	});
}

function sendEventRegistrationApiRequest(eventId, eventDateId)
{
	axios.post('/rd-api/events', {
		'craft_event_id': eventId,
		'craft_date_id': eventDateId
	})
	.then(function (response) {
		if(response.data.action === 'add') {
			Swal.fire({
				title: 'Success',
				text: 'You are now subscribed to receive event reminders.',
				icon: 'info',
				confirmButtonText: 'Ok',
				confirmButtonColor: '#b73436',
			  });
		}

		if(response.data.action === 'remove') {
			Swal.fire({
				title: 'Unsubscibed',
				text: 'You are now unsubscribed from receving reminders for this event time.',
				icon: 'info',
				confirmButtonText: 'Ok',
				confirmButtonColor: '#b73436',
			  });
		}
	})
	.catch(function (error) {
		if(error.response.status === 401)
		{
			return window.location.replace("/account");
		}
	});
}

document.addEventListener("DOMContentLoaded", function () {
	document.addEventListener("click", toggleEventRegistration);
	document.addEventListener("touchend", toggleEventRegistration);
});